import { EMessengerScreenName, type TMessengerErpLayoutMode } from '@xometry/ui';

export interface ReinitLikePayload {
  initialScreen?: {
    name: EMessengerScreenName;
  };
  initialMessageId?: string;
}

export interface GetErpMessengerLayoutModeForMessengerPayloadArgs {
  userPreference: TMessengerErpLayoutMode;
  isMobile: boolean;
  isEmbedded: boolean;
  payload: ReinitLikePayload;
}

export const getErpMessengerLayoutModeForMessengerPayload = ({
  userPreference,
  isMobile,
  isEmbedded,
  payload,
}: GetErpMessengerLayoutModeForMessengerPayloadArgs): TMessengerErpLayoutMode => {
  if (isMobile || isEmbedded) return 'classic';

  if (payload.initialMessageId) return userPreference;

  if (payload.initialScreen) {
    const name = payload.initialScreen.name;

    if (name === EMessengerScreenName.CHAT || name === EMessengerScreenName.EMPTY) return userPreference;
  }

  return 'classic';
};
